import { GET_WEBSITE_BUILDER_GOOGLE_REVIEW } from '../../constants';

const initialState = {
  websiteBuilderGoogleReviews: [],
};

export const GetWebsiteBuilderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WEBSITE_BUILDER_GOOGLE_REVIEW:
      return {
        ...state,
        websiteBuilderGoogleReviews: action.payload,
      };
    default:
      return state;
  }
};
